import { connect } from "react-redux"
import { withRouter } from "react-router"
import { compose } from "redux"
import DeviceIdInput from "./DeviceIdInput"
import { setNodeId, setMasterId } from "store/actions/setters"

const getDisplayedLocationIds = (state, props) => {
	const params = new URLSearchParams(props.location.search)
	const deviceIds = params.get("deviceid-input")
	return deviceIds || ""
}

const handleClose = (props) => {
	const params = new URLSearchParams(props.location.search)
	params.delete("deviceid-input")
	props.history.push({
		pathname: props.location.pathname,
		search: "?" + params.toString(),
	})
}

const mapStateToProps = (state, props) => ({
	locIds: getDisplayedLocationIds(state, props),
})

const handleAccept = (dispatch, props) => async (deviceid) => {
	const params = new URLSearchParams(props.location.search)
	let locIds = params.get("deviceid-input")
	if (!locIds) return null
	locIds = locIds.split(":")
	if (locIds.length === 3) {
		dispatch(setNodeId(locIds[0], locIds[1], locIds[2], deviceid))
	} else if (locIds.length === 2) {
		dispatch(setMasterId(locIds[0], locIds[1], deviceid))
	}
	handleClose(props)
}

const mapDispatchToProps = (dispatch, props) => ({
	handleClose: () => handleClose(props),
	handleAccept: handleAccept(dispatch, props),
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(DeviceIdInput)
